import React, { useState, useEffect, useRef } from 'react'
import aboutimg from '../../assets/images/Aboutus/about1.webp'
import chennai from '../../assets/images/Aboutus/about2.webp'
import comfort from '../../assets/images/Aboutus/about3.webp'
import kumaran from '../../assets/images/Aboutus/about4.webp'
import Boutiques from '../../assets/images/Aboutus/about5.webp'
import election from '../../assets/images/Aboutus/about6.webp'
import skin from '../../assets/images/Aboutus/about7.webp'
import hydro from '../../assets/images/Aboutus/about8.webp'
import Joinus from '../../common/Joinus'

const AboutContent = () => {
  const aboutus = [
    { id: 0, title: "Chennai Silks Textiles", image: chennai, content: "Chennai Silks is a prominent textile retailer in India. SMS ZOO ZOO revitalized the brand's legacy. This combined tradition with modern marketing.", header1: "SMS Marketing", headcontent: "SMS campaigns drove direct sales.", header2: "WhatsApp Ads", headcontent2: "Engaged customers with personalized offers.", header3: "Brand Promotion", headcontent3: "Elevated brand visibility and recall." },
    { id: 1, title: "Home Today Furniture: Digital Crafting", image: comfort, content: "Home Today Furniture offers quality furniture. We crafted immersive digital experiences. These attracted customers.", header1: "Social Media Ads", headcontent: "Increased website traffic.", header2: "Digital Experiences", headcontent2: "Enhanced customer engagement.", header3: "Online presence", headcontent3: "Extended reach to new customers." },
    { id: 2, title: "Sree Kumaran Thangamaligai", image: kumaran, content: "Sree Kumaran Jewellery is a trusted name in fine jewellery. SMS ZOO ZOO created a new collection launch campaign. It boosted brand visibility and revenue.", header1: "Announced new collections.", header2: "Promoted special offers via SMS.", header3: "Shared exclusive deals on WhatsApp." },
    { id: 3, title: "Sri Naachammal Boutiques", image: Boutiques, content: "Sri Naachammal Boutiques offers premium clothing. Our brand promotion increased store traffic. It also boosted sales.", header1: "Sarees Collection Offer", headcontent: "Drove traffic to Saree's \nCollection.", header2: "Brand Promotion", headcontent2: "Increased Brand \nrecognition and loyalty." },
    { id: 4, title: "Tamil Nadu Election Commission", image: election, content: "Tamil Nadu Election Commission ensures democratic elections. Our awareness campaign promoted participation and transparency.", header1: "Vote \nPromotion", header2: "Voter \nTurnout", header3: "100% \nParticipation" },
    { id: 5, title: "Mammapure Skin Care: E-commerce Boost", image: skin, content: "Mammapure is a skin care brand. SMS ZOO ZOO drove online growth. This involved optimized websites and targeted marketing.", header1: "Sales \nGrowth", header2: "Increased \nTraffic", header3: "Brand \nAwareness" },
    { id: 6, title: "L&T - Hydrocarbon", image: hydro, content: "We enhanced L&T Hydrocarbon's worker engagement by providing real-time project updates and streamlined communication via WhatsApp." },
  ];
  const getStyleClass = (id) => {
    switch (id) {
      case 0:
        return "border-gray resmargin";
      case 1:
        return "border-gray";
      case 4:
        return "border-gray ";
      case 5:
        return "border-gray";
      case 2:
      case 3:
        return "border-gray ";
      case 6:
        return "";
      default:
        return "";
    }
  };
  const [activeSection, setActiveSection] = useState("");
  const sectionRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      let currentSection = "vision";

      sectionRefs.current.forEach((section) => {
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 200 && rect.bottom >= 200) {
            currentSection = section.dataset.section;
          }
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className='margin-topall'>
      <section className='pt-5 overflow-hidden'>
        <div className='container'>
          <div className='About_header'>
            <h1> About Us </h1>
          </div>
          <div className='About-para py-2'
            data-aos="fade-left" data-aos-delay="300"
          >
            Founded in 2016, SMS ZOO ZOO has grown into a leading digital marketing <br /> company, specializing in SMS marketing, RCS messaging, WhatsApp <br />Business API, and performance-driven digital advertising.
          </div>
          <div className='imgflex'>
            <img src={aboutimg} alt='About' className='aboutimg' />
          </div>
        </div>
      </section>
      <section className='py-5 paddingpy overflow-hidden'>
        <div className='About_header1'>
          <h1
            data-aos="fade-down" data-aos-delay="300"
          >Our Journey & Achievements</h1>
        </div>
        <div className="container ">
          <div className='row'>
            <div className="col-md-6 col-sm-6 border-t"></div>
            <div className="col-md-6 col-sm-6"></div>
          </div>
        </div>

        <div className="container">
          <div className='linemargin'>
            {aboutus.map((item, index) => (
              <div className={`row align-items-center positionmd py-4 ${index === 6 ? 'border-b' : index === 0 ? 'overallborderodd1' : index % 2 === 0 ? 'overallborderodd' : 'overallbordereven'}`}
                key={index}>
                <div className={`col-md-1 text-center  ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-3'}`}>
                  <div className={`circle ${index % 2 === 0 ? 'marginodd' : 'margineven positioncd'}`}>{index + 1}</div>
                </div>
                <div className={`col-md-7 ${index % 2 === 0 ? 'order-lg-2 alignleft' : 'order-lg-2 alignright'}`}
                  data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`} data-aos-delay="300"
                >
                  <h3 className='titleabt'>{item.title}</h3>
                  <div className={`row ${getStyleClass(item.id)}`}>
                    {item.id === 6 ? (
                      <div className="col-12 ">
                        <p>{item.content}</p>
                      </div>
                    ) : item.id === 3 ? (
                      <>
                        <div className="col-md-6 border-r paddingcol ">
                          <h5 className='alignhead'><b>{item.header1}</b></h5>
                          <p className='alignpara'>{item.headcontent}</p>
                        </div>
                        <div className="col-md-6 paddingcol ">
                          <h5 className='alignhead'><b>{item.header2}</b></h5>
                          <p className='alignpara'>{item.headcontent2}</p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-md-4 paddingcol">
                          <h5 className={`alignhead ${(index === 4 || index === 5) ? (index % 2 === 0 ? 'marginpl' : 'marginpr') : ''}`}>
                            <b>{item.header1}</b>
                          </h5>
                          <p className='alignpara'>{item.headcontent}</p>
                        </div>
                        <div className="col-md-4 border-rl paddingcol">
                          <h5 className={`alignhead ${(index === 4 || index === 5) ? (index % 2 === 0 ? 'marginpl' : 'marginpr') : ''}`}><b>{item.header2}</b></h5>
                          <p className='alignpara'>{item.headcontent2}</p>
                        </div>
                        <div className="col-md-4 paddingcol">
                          <h5 className={`alignhead ${(index === 4 || index === 5) ? (index % 2 === 0 ? 'marginpl' : 'marginpr') : ''}`}><b>{item.header3}</b></h5>
                          <p className='alignpara'>{item.headcontent3}</p>
                        </div>
                      </>
                    )}
                  </div>
                  {item.id !== 6 && <p className='py-3'>{item.content}</p>}
                </div>
                <div className={`col-md-4 ${index % 2 !== 0 ? 'order-lg-1 alignstart' : 'order-lg-3 alignend'}`}
                  data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
                >
                  <img src={item.image} alt={item.title} className="gridimg" />
                </div>
              </div>
            ))}
          </div>
        </div>

      </section>
      <section className="vision-mission web-block ">
        <div className="container">
          <div className="row">
            <div className="col-md-5 sticky-container">
              <div className="sticky-headings">
                <p className={`heading visionhead ${activeSection === "vision" ? "active" : ""}`}>VISION</p>
                <p className={`heading visionhead ${activeSection === "mission" ? "active" : ""}`}>MISSION</p>
                <p className={`heading visionhead ${activeSection === "core-values" ? "active" : ""}`}>CORE VALUES</p>
              </div>
            </div>
            <div className="col-md-6 content-section">
              <div ref={(el) => (sectionRefs.current[0] = el)} data-section="vision" className="visionpara ">
                <span>To become</span> a global leader in digital communication, <span >empowering businesses with </span> innovative, reliable, and high-impact messaging solutions <span>that drive engagement and growth.</span>
              </div>
              <div ref={(el) => (sectionRefs.current[1] = el)} data-section="mission" className="visionpara">
                <p>
                  <span className='boldspan'>  To </span>expand our reach  <span className='boldspan'> across industries, making digital communication accessible and effective.</span>
                </p>
              </div>
              <div ref={(el) => (sectionRefs.current[2] = el)} data-section="core-values" className="visionpara">
                <p>
                  Growth & Collaboration – <span className='boldspan'>We grow with our clients, building</span> long-term partnerships <span className='boldspan'>that drive success</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='container mob-block'>
        <div className='vision-mission'>
          <div className='missionfont mt-5'>
            <h5 className='headingmob'>
              VISION
            </h5>
            <p>
            To become a global leader in digital communication, empowering businesses with innovative, reliable, and high-impact messaging solutions that drive engagement and growth.
            </p>
          </div>
          <div className='listmission mt-5'>
            <h5 className='headingmob'>
              MISSION
            </h5>
           <p>
           To expand our reach across industries, making digital communication accessible and effective.
           </p>
          </div>
          <div className='listmission mt-5'>
            <h5 className='headingmob'>
              CORE VALUES
            </h5>
            Growth & Collaboration – We grow with our clients, building long-term partnerships that drive success
          </div>

        </div>

      </section>
      <Joinus />
    </div>
  )
}

export default AboutContent